import { SELECT_INPUT_TYPE, VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";
import { CLIENT_SHIPPING_MODES } from "@utils/ClientShipping";

/** Valor del select de opciones que habilita la captura manual. */
export const MANUAL_SHIPPING_OPTION = "manual";

/**
 * El usuario elige una de las opciones configuradas para el cliente. Los campos de
 * modalidad y proveedor solo aparecen en captura manual: cuando se elige una opcion
 * guardada, esos datos ya vienen de la ficha del cliente y no hay nada que decidir.
 */
const ShippingCostFormConfig = {
    sections: [
        {
            hideBorderBottom: true,
            "fields": [
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "optionId",
                        "label": "Opcion de Envio",
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "mode",
                        "label": "Modalidad de Envio",
                        "options": CLIENT_SHIPPING_MODES,
                        "visibleIf": {
                            "optionId": MANUAL_SHIPPING_OPTION
                        },
                        "validation": Yup.string().when("optionId", {
                            is: (optionId: unknown) => `${optionId || ""}` === MANUAL_SHIPPING_OPTION,
                            then: (s) => s.required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                            otherwise: (s) => s.notRequired(),
                        }),
                    }
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "providerId",
                        "label": "Proveedor de Envio",
                        "visibleIf": {
                            "mode": "external"
                        },
                    }
                ],
                [
                    {
                        // El monto no lleva validacion Yup: el input `money` entrega el valor
                        // ya formateado y `Yup.number()` lo rechazaria. Lo valida
                        // `handleSubmit`, que es tambien quien decide si se agrega o no.
                        "type": "money",
                        "name": "amount",
                        "label": "Monto del Envio",
                    }
                ],
                [
                    {
                        "type": "text",
                        "name": "detalle",
                        "label": "Detalle",
                        "maxlength": 160,
                    }
                ],
                [
                    {
                        // Nace marcado solo si el perfil tiene `create_shipping_guide` activo:
                        // lo siembra `buildInitialValues` en el offcanvas.
                        "type": "checkbox",
                        "name": "print_guide",
                        "label": "Imprimir guia de envio",
                    }
                ],
                [
                    {
                        // Los bultos son a la vez un dato de la guia y la cantidad de copias
                        // que se imprimen de ella, por eso no puede ser cero.
                        "type": "number",
                        "name": "bultos",
                        "label": "Cantidad de Bultos",
                        "visibleIf": {
                            "print_guide": true
                        },
                        "validation": Yup.number().when("print_guide", {
                            is: true,
                            then: (s) => s
                                .typeError("La cantidad de bultos debe ser un numero")
                                .integer("La cantidad de bultos debe ser un numero entero")
                                .min(1, "La cantidad de bultos debe ser al menos 1")
                                .required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                            otherwise: (s) => s.notRequired(),
                        }),
                    }
                ],
            ]
        }
    ],
};

export default ShippingCostFormConfig;
